import {PROVIDER_FLAGS} from '@Constants/index.constants.js';

export const ViewAcceptedState = {
	url: '/accepted/:customerToken/:serviceProviderId/:consultationId/:proposalId?showBack',
	title: 'View Accepted Proposal',
	params: {
		customerToken: null,
		serviceProviderId: null,
		consultationId: null,
		proposalId: null,
		showBack: null,
	},
	// One state, one URL: the v2 provider flag decides which component renders, so both
	// versions live behind the same path. lazyLoad resolves the flag before importing, to
	// pull only the chunk that will actually render, and shares that lookup with the
	// providerFlags resolve below so the two cannot disagree. This state is in publicStates,
	// so getPresentationFlags reads the flag from the customer endpoint, which needs the
	// customerToken, serviceProviderId and consultationId already in the URL.
	templateProvider: [
		'providerFlags',
		providerFlags =>
			providerFlags?.[PROVIDER_FLAGS.PRESENTATION_V2]
				? '<view-accepted-v2 provider-flags="$resolve.providerFlags"></view-accepted-v2>'
				: '<view-accepted provider-flags="$resolve.providerFlags"></view-accepted>',
	],
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		const RoutesSvc = $transition$.injector().get('RoutesResolveSvc');
		return (
			RoutesSvc.getPresentationFlags({trans: $transition$})
				// a failed lookup imports the production page; the providerFlags resolve below
				// reports the failure, so it is not swallowed here
				.catch(() => ({}))
				.then(flags =>
					flags?.[PROVIDER_FLAGS.PRESENTATION_V2]
						? import(
								/* webpackChunkName: "viewAcceptedV2Mod" */
								'@Containers/view-accepted-page/view-accepted-v2.cmp.js'
							)
						: import(
								/* webpackChunkName: "viewAcceptedPageMod" */
								'@Containers/view-accepted-page/view-accepted.cmp.js'
							)
				)
				.then(res => $ocLazyLoad.load({name: res.default}))
				.catch(err => $log.error(err))
		);
	},
	resolve: [
		{
			token: 'canView',
			policy: {when: 'EAGER'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) =>
				RoutesSvc.validateConsultationPublic({status: 'accepted', ...trans.params()}).catch(state => {
					trans.router.stateService.go(state.name, state.params);
				}),
		},
		{
			token: 'providerFlags',
			policy: {when: 'LAZY'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) => RoutesSvc.getPresentationFlags({trans}),
		},
	],
};
